
import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="app-footer">
      <Link to="/support">Support</Link>
      <a href="https://thrillartsauction.com" target="_blank" rel="noopener noreferrer">Auction</a>
      <a href="https://thrillartsMusic.com">Music</a>
      <Link to="/animation">Animation Services</Link>
      <Link to="/products">Products & 3D Assets</Link>
      <Link to="/hire-artist">Hire an Artist</Link>
      <Link to="/hire-developer">Hire a Developer</Link>
      <Link to="/franchise">Franchise</Link>
      <Link to="/contact-us">Contact Us</Link>
      <Link to="/privacy-policy">Privacy Policy</Link>
      <Link to="/sponsorship">Sponsorship</Link>
      <Link to="/metaverse-rental">Metaverse Rental</Link>
    </footer>
  );
}

export default Footer;
